import { render, staticRenderFns } from "./VueXlsxTable.vue?vue&type=template&id=10d653ff&scoped=true&"
import script from "./VueXlsxTable.vue?vue&type=script&lang=js&"
export * from "./VueXlsxTable.vue?vue&type=script&lang=js&"
import style0 from "./VueXlsxTable.vue?vue&type=style&index=0&id=10d653ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d653ff",
  null
  
)

export default component.exports